import { CommonMainPage } from '../../widgets/utility/CommonMainPage'
import { LiveUncloakingFilters } from './widgets/LiveUncloakingFilters'
import { BpTab } from '../../shared/components/utility/tabs/tab/BpTab'
import { BpTabs } from '../../shared/components/utility/tabs/BpTabs'
import { useAppDispatch, useAppSelector } from '../../app/store/hooks/Redux'
import {
  selectLiveUncloakingApplyFilters,
  selectLiveUncloakingExclude,
  selectLiveUncloakingFilters,
  selectLiveUncloakingTab,
  setLiveUncloakingApplyFilters,
  setLiveUncloakingExcludeIds,
  setLiveUncloakingTab,
  TLiveUncloakingTabs,
} from './model/liveUncloakingSlice'
import { useLazyGetDecloakLiveQuery } from '../../app/api'
import { useEffect } from 'react'
import { ScreenReport } from './widgets/screen-report/ScreenReport'
import { LinksReport } from './widgets/links-report/LinksReport'
import { HtmlReport } from './widgets/html-report/HtmlReport'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

import styles from './LiveUncloakingPage.module.scss'

export const LiveUncloakingPage = () => {
  const { t } = useTranslation()
  const apply = useAppSelector(selectLiveUncloakingApplyFilters)
  const filters = useAppSelector(selectLiveUncloakingFilters)
  const exclude = useAppSelector(selectLiveUncloakingExclude)
  const activeTab = useAppSelector(selectLiveUncloakingTab)
  const dispatch = useAppDispatch()

  const [liveUncloaking, { data, isLoading, isFetching }] = useLazyGetDecloakLiveQuery()

  useEffect(() => {
    if (filters.device && filters.country && filters.site && apply)
      liveUncloaking({
        deviceId: +filters.device,
        countryId: +filters.country,
        site: filters.site,
        exludeIds: exclude.excludeProxy ? exclude.excludeIds : undefined,
      }).then(({ data }) => {
        dispatch(setLiveUncloakingApplyFilters(false))
        dispatch(setLiveUncloakingExcludeIds(data?.data?.ids))
      })
  }, [filters, exclude.excludeProxy, apply])

  return (
    <CommonMainPage
      hint={t('navigation.hint.liveUncloaking')}
      title={t('navigation.liveUncloaking')}
    >
      <LiveUncloakingFilters />
      <BpTabs
        active={activeTab}
        className={clsx(styles.tabs)}
        size={'md'}
        onToggle={(e) => dispatch(setLiveUncloakingTab(e as TLiveUncloakingTabs))}
      >
        <BpTab title={t('pages.liveUncloaking.screenshots')}>
          <ScreenReport isLoading={isLoading || isFetching} screen={data?.data?.webScreen} />
        </BpTab>
        <BpTab title={t('pages.liveUncloaking.HTML')}>
          <HtmlReport html={data?.data?.webHtml} isLoading={isLoading || isFetching} />
        </BpTab>
        <BpTab title={t('pages.liveUncloaking.links')}>
          <LinksReport isLoading={isLoading || isFetching} links={data?.data?.redirects} />
        </BpTab>
      </BpTabs>
    </CommonMainPage>
  )
}
